module.exports = __webpack_public_path__ + "static/media/icn_community.d4faeb9c.svg";